import { render, staticRenderFns } from "./SingleTabActivitiesSection.vue?vue&type=template&id=61f3359e&"
import script from "./SingleTabActivitiesSection.vue?vue&type=script&lang=js&"
export * from "./SingleTabActivitiesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports